import React from "react";
import "./homeproducts.css";
const Products = () => {
  return (
    <>
      <section className="h-products" id="products">
        <div className="section-title-area ltn__section-title-2--- text-center">
          <h6 className="section-subtitle section-subtitle-2 ">Our Products</h6>
          <h1 className="section-title">
            Extended Trust <span> Products</span>
          </h1>
        </div>
        <div className="products-cards">
          <a href="/products" class="flip-card" tabIndex="0">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <span className="category-icon">
                  <i className="fas fa-oil-can" />
                </span>
                <h5 style={{ maxWidth: "210px" }}>
                  {" "}
                  {/* Path to Worry Free Driving Program */}
                  OIL CHANGE PROGRAM
                </h5>
              </div>
              <div class="flip-card-back ">
                <p>
                  Worry free driving with our oil change program. Comprehensive
                  five year plan with the option to extend for a lifetime.
                  Convenience of regular oil changes, ensuring an engine's
                  optimal performance. Extend the life of your vehicle with our
                  hassle free and cost effective program.
                </p>
              </div>
            </div>
            <div className="category-btn">
              <i class="fa fa-arrow-right" style={{ color: "white" }}></i>
            </div>
          </a>
          <a href="/products" class="flip-card" tabIndex="5">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <span className="category-icon">
                  <i className="fas fa-car" />
                </span>{" "}
                <h5 style={{ maxWidth: "210px" }}>Brakes and Rotors</h5>
              </div>
              <div class="flip-card-back">
                <p>
                  Prioritize safety with our "Brakes and Rotors" program.
                  Comprehensive coverage for your braking system ensures optimal
                  performance and responsiveness. From brake pad replacements to
                  rotor maintenance, trust us to keep your vehicle braking
                  smoothly, providing you with peace of mind on every journey.
                </p>
              </div>
            </div>
            <div className="category-btn">
              <i class="fa fa-arrow-right" style={{ color: "white" }}></i>
            </div>
          </a>
          <a href="/products" class="flip-card" tabIndex="6">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <span className="category-icon">
                  <i className="fas fa-eye" />
                </span>{" "}
                <h5 style={{ maxWidth: "210px" }}>Customized programs</h5>
              </div>
              <div class="flip-card-back">
                <p>
                  Customized programs give customers exactly what they need, creating a more relevant and flexible experience that builds trust, improves satisfaction, and increases long-term loyalty.
                </p>
              </div>
            </div>
            <div className="category-btn">
              <i class="fa fa-arrow-right" style={{ color: "white" }}></i>
            </div>
          </a>
        </div>
      </section>
    </>
  );
};

export default Products;
